import angular from 'angular'

angular.module('app.hub', [])
  .controller('hub.controller', () => {})
